import login from "./login";
import server from "./server";
import translation from "./translation";
import translator from "./translator";
import messages from "./messages";
import helpers from "./helpers";
import selects from "./selects";
import permissions from "./permissions";
import bus from "./bus";
import toaster from "./toaster";
import defaults from "./defaults";
import shared from "./shared";
export default {
    login,
    server,
    translation,
    messages,
    helpers,
    selects,
    permissions,
    bus,
    toaster,
    defaults,
    translator,
    shared
}




// WEBPACK FOOTER //
// ./src/public_app/api/index.js